import { render, staticRenderFns } from "./ProductAndCartCoupon.vue?vue&type=template&id=4b6af0b0&"
import script from "./ProductAndCartCoupon.vue?vue&type=script&lang=ts&"
export * from "./ProductAndCartCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports